interface Props {
  adminName: string;
}

export function OperatorLockBanner({ adminName }: Props) {
  return (
    <output
      data-testid="operator-lock-banner"
      className="bg-warning-50 border-b border-warning-200 dark:bg-warning-950/20 dark:border-warning-900/40 text-warning-700 dark:text-warning-300 text-sm px-6 py-2 block"
    >
      En atención por <strong>{adminName}</strong>. No puedes enviar mensajes mientras otro operador
      maneja esta conversación.
    </output>
  );
}
